import { ViewModel,View, ObservableArray } from "binder"
import moment from "moment";
import { GenderSelector } from "src/common/reusableComponents/genderSelector/genderSelector";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import  { PersonnelManipulationView } from "./personnelManipulation-view"

export class PersonnelManipulationViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'مدیریت پرسنل';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        
        this.personnel = ObservableArray.create<personnel>();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),15);
        this.refresh();
    }
    GetDefaultView(): View <ViewModel> {
        return new PersonnelManipulationView();
    }
    public getTypeId(): string {
        return "VM-BADBC565-2EC4-47F0-8FC1-55375DE3741D"
    }
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set personnel(v: ObservableArray<personnel>) { this._personnel = v; } public get personnel(): ObservableArray<personnel> { return this._personnel;} private _personnel: ObservableArray<personnel>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
        
    refresh(){
        this.loader.refresh();
    }
    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/EnterpriseAdministrationServices/GetAllPersonnels',{
                ShowActive: false,
                ShowAll : true,
                ShowDeleted : true,
                FilteringInformation:filteringInformation
            });
            this.personnel.update(...result.Personnels.map(x=>{
                let r = new personnel(this);
                r.name=x.Name;
                r.address=x.Address;
                r.birthDate=x.BirthDate==null ? null : moment.utc(x.BirthDate);
                r.cellPhone=x.CellPhone;
                r.comment=x.Comment;
                r.fatherName=x.FatherName;
                r.id=x.Id;
                r.identificationCode=x.IdentificationCode;
                r.isMale=x.IsMale;
                r.gender=r.isMale ? 'مرد' : 'زن';
                r.lastname=x.LastName;
                r.nationalCode=x.NationalCode;
                r.canAutomaticPrintDeliveryItem = x.CanGetAutomaticPrint;
                r.canAutomaticPrintSendableItem = x.CanAutomaticPrintSendableItem;
                r.code = x.PersonnelCode;
                r.isDeleted = x.IsDeleted;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }
    
    async requestCreation() {
        let inserter = new personnelEditor(this,new InsertServerUpdater());
        let resultCode = await this.showPopup(inserter);
        if(resultCode=='done'){
            this.loader.refresh();
        }
    }
    
    async personnelUpdater(personnel:personnel){
        let editor = new personnelEditor(this,new UpdateServerUpdater());
        personnel.cloneTo(editor);
        let resultCode = await this.showPopup(editor);
        if(resultCode=='done'){
            this.loader.refresh();
        }
    }
    
    async remove(id:any){
        try {
            this.isLoading = true;
            await ServerConnection.callServer('/Complex/EnterpriseAdministrationServices/DeActivePersonnel',{
                PersonnelId:id
            });
            await this.messageBoxConfirmSuccess('پرسنل حذف شد','عملیات موفق');
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
            this.loader.refresh();
        }
    }
    
    async reActive(id:any){
        try {
            this.isLoading = true;
            await ServerConnection.callServer('/Complex/EnterpriseAdministrationServices/ReActivePersonnel',{
                PersonnelId:id
            });
            await this.messageBoxConfirmSuccess('پرسنل فعال شد','عملیات موفق');
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
            this.loader.refresh();
        }
    }
}

export class personnel extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:PersonnelManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
        this.password = "";
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set lastname(v: string) { this._lastname = v; } public get lastname(): string { return this._lastname;} private _lastname: string;
    public set birthDate(v: moment.Moment) { this._birthDate = v; } public get birthDate(): moment.Moment { return this._birthDate;} private _birthDate: moment.Moment;
    public set cellPhone(v: string) { this._cellPhone = v; } public get cellPhone(): string { return this._cellPhone;} private _cellPhone: string;
    public set comment(v: string) { this._comment = v; } public get comment(): string { return this._comment;} private _comment: string;
    public set fatherName(v: string) { this._fatherName = v; } public get fatherName(): string { return this._fatherName;} private _fatherName: string;
    public set identificationCode(v: string) { this._identificationCode = v; } public get identificationCode(): string { return this._identificationCode;} private _identificationCode: string;
    public set isMale(v: boolean) { this._isMale = v; } public get isMale(): boolean { return this._isMale;} private _isMale: boolean;
    public set canAutomaticPrintDeliveryItem(v: boolean) { this._canAutomaticPrintDeliveryItem = v; } public get canAutomaticPrintDeliveryItem(): boolean { return this._canAutomaticPrintDeliveryItem;} private _canAutomaticPrintDeliveryItem: boolean;
    public set canAutomaticPrintSendableItem(v: boolean) { this._canAutomaticPrintSendableItem = v; } public get canAutomaticPrintSendableItem(): boolean { return this._canAutomaticPrintSendableItem;} private _canAutomaticPrintSendableItem: boolean;
    public set gender(v: string) { this._gender = v; } public get gender(): string { return this._gender;} private _gender: string;
    public set nationalCode(v: string) { this._nationalCode = v; } public get nationalCode(): string { return this._nationalCode;} private _nationalCode: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code;} private _code: string;
    public set address(v: string) { this._address = v; } public get address(): string { return this._address;} private _address: string;
    public set password(v: string) { this._password = v; } public get password(): string { return this._password;} private _password: string;
    public set isEdited(v: boolean) { this._isEdited = v; } public get isEdited(): boolean { return this._isEdited;} private _isEdited: boolean;
    public set isDeleted(v: boolean) { this._isDeleted = v; } public get isDeleted(): boolean { return this._isDeleted;} private _isDeleted: boolean;
    
    private _typedParent:PersonnelManipulationViewModel;

    cloneTo(personnel:personnel){
        personnel.id = this.id;
        personnel.name = this.name;
        personnel.lastname = this.lastname;
        personnel.birthDate = this.birthDate?.clone();
        personnel.cellPhone = this.cellPhone;
        personnel.comment = this.comment;
        personnel.fatherName = this.fatherName;
        personnel.identificationCode = this.identificationCode;
        personnel.setIsMale(this.isMale);
        personnel.gender=personnel.isMale ? 'مرد' : 'زن';
        personnel.nationalCode = this.nationalCode;
        personnel.canAutomaticPrintDeliveryItem = this.canAutomaticPrintDeliveryItem;
        personnel.canAutomaticPrintSendableItem = this.canAutomaticPrintSendableItem;
        personnel.code = this.code;
        personnel.address = this.address;
        personnel.password = this.password;
        personnel.isEdited = true;
    }
    setIsMale(isMale: boolean) {
        this.isMale = isMale;
    }

    async edit(){
        this._typedParent.personnelUpdater(this);
    }

    async remove(){
        let result:string; 
        result = await this.messageBoxWarningYesNo('آیا مطمئنید؟','حذف پرسنل');
        if(result=='yes'){
            this._typedParent.remove(this.id);
        }
    }

    async reActive(){
        let result:string; 
        result = await this.messageBoxWarningYesNo('آیا مطمئنید؟','فعال کردن مجدد پرسنل');
        if(result=='yes'){
            this._typedParent.reActive(this.id);
        }
    }
}

interface IServerUpdate{
    execute(personnel:personnel):Promise<void>;
    getSuccessMessage():string;
}

class InsertServerUpdater implements IServerUpdate{

    getSuccessMessage(): string {
        return 'پرسنل با موفقیت ثبت شد.';
    }
    async execute(personnel:personnel): Promise<void> {
        try {
            let result =  await ServerConnection.callServer('/Complex/EnterpriseAdministrationServices/CreatePersonnel',{
                Name : personnel.name,
                LastName : personnel.lastname,
                NationalCode : personnel.nationalCode,
                PersonnelCode : personnel.code,
                FatherName : personnel.fatherName,
                IdentificationCode : personnel.identificationCode,
                BirthDate : personnel.birthDate,
                Comment : personnel.comment,
                Address : personnel.address,
                CellPhone : personnel.cellPhone,
                IsMale : personnel.isMale,
                CanGetAutomaticPrint : personnel.canAutomaticPrintDeliveryItem,
                CanAutomaticPrintSendableItem : personnel.canAutomaticPrintSendableItem,
                ShallCreateUser : true,
                Username : personnel.code,
                Password : personnel.password
            });
            if(result.IsSuccessful==false){
                throw "new Error";
            }
        } catch (ex) {
            console.log(ex);
            throw ex;
        } finally {
        }
    }
}

class UpdateServerUpdater implements IServerUpdate{
    getSuccessMessage(): string {
        return 'پرسنل با موفقیت به روز رسانی شد.';

    }
    async execute(personnel:personnel): Promise<void> {
        try {
            let result =  await ServerConnection.callServer('/Complex/EnterpriseAdministrationServices/UpdatePersonnel',{
                PersonnelId : personnel.id,
                Name : personnel.name,
                LastName : personnel.lastname,
                NationalCode : personnel.nationalCode,
                FatherName : personnel.fatherName,
                IdentificationCode : personnel.identificationCode,
                BirthDate : personnel.birthDate,
                Comment : personnel.comment,
                Address : personnel.address,
                CellPhone : personnel.cellPhone,
                CanGetAutomaticPrint : personnel.canAutomaticPrintDeliveryItem,
                CanAutomaticPrintSendableItem : personnel.canAutomaticPrintSendableItem,
                IsMale : personnel.isMale,
                Password : personnel.password
            });
            if(result.IsSuccessful==false){
                throw "new Error";
            }
        } catch (ex) {
            console.log(ex);
            throw ex;
        } finally {
        }
    }
}

export class personnelEditor extends personnel implements IPopup{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:PersonnelManipulationViewModel,updater : IServerUpdate) {
        super(parent);
        this.updater = updater;
        this.genderSelector = new GenderSelector(this);
        this.genderSelector.onSelectionChanged = x=> this.isMale = x.value;
    }
    closePopup(resultCode: string = null) {}

    public set genderSelector(v: GenderSelector) { this._genderSelector = v; } public get genderSelector(): GenderSelector { return this._genderSelector;} private _genderSelector: GenderSelector;
    
    public set isSuccessful(v: boolean) { this._isSuccessful = v; } public get isSuccessful(): boolean { return this._isSuccessful;} private _isSuccessful: boolean;
    public set isFailed(v: boolean) { this._isFailed = v; } public get isFailed(): boolean { return this._isFailed;} private _isFailed: boolean;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    private updater : IServerUpdate;
    
    setIsMale(isMale: boolean) {
        this.isMale = isMale;
        let genderId = isMale===true ? 'male' : isMale===false ? "female" : null;
        this.genderSelector.selectById(genderId);
    }
    verify():string[]{
        let result :string[] =[];
        if(stringIsNullOrEmpty(this.name)){
            result.push('نام پرسنل مشخص نشده است.')
        }
        if(stringIsNullOrEmpty(this.lastname)){
            result.push('نام خانوادگی پرسنل مشخص نشده است.')
        }
        if(stringIsNullOrEmpty(this.fatherName)){
            result.push('نام پدر مشخص نشده است.')
        }
        if(stringIsNullOrEmpty(this.code)){
            result.push('کد پرسنلی مشخص نشده است.')
        }
        if(stringIsNullOrEmpty(this.password) && stringIsNullOrEmpty(this.id)){
            result.push('رمز عبور مشخص نشده است.')
        }
        if(stringIsNullOrEmpty(this.identificationCode)){
            result.push('شماره شناسنامه مشخص نشده است.')
        }
        if(stringIsNullOrEmpty(this.nationalCode)){
            result.push('شماره ملی مشخص نشده است.')
        }
        return result;
    }    
    async save(){
        try {
            let verificationResult = this.verify();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'عدم امکان ثبت پرسنل');
                return;
            }     
            this.isLoading = true;
            await this.updater.execute(this);
            await this.messageBoxConfirmSuccess(this.updater.getSuccessMessage(),'عملیات موفق');
            this.closePopup("done")         
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
        }
    }

    back(){
        this.closePopup();
    }
}


